import { render, staticRenderFns } from "./RealtimeDashboard.vue?vue&type=template&id=a942f084&"
import script from "./RealtimeDashboard.vue?vue&type=script&lang=js&"
export * from "./RealtimeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeDashboard.vue?vue&type=style&index=0&id=a942f084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports